/**
 * Every abstract type in the API schema, mapped to its concrete members.
 *
 * Apollo's `InMemoryCache` needs this to match a fragment declared ON an abstract type
 * (`fragment SearchHitNodeFields on SearchResultNode`) against a concrete cached object.
 * A missing entry does not warn in a production build: nothing in the fragment matches, so
 * the cache stores the union member as `{ __typename, id }`, DROPS every field the fragment
 * selected, and hands the component back that hollow object. A card that reads a scalar it
 * has always had — `comment.content.match(...)` — throws mid-render and takes the page down
 * with it. That is what `SearchResultNode` did to community search's "load more".
 *
 * Only fragments whose type condition IS the abstract type need this; an inline
 * `... on CommunityPost` matches on the name alone. So does a query that skips the cache
 * (`fetchPolicy: 'no-cache'`, which is why the search typeahead never broke), and so does
 * any server component, which fetches over plain HTTP with no cache in the path. Hence the
 * shape of the bug: the first, server-rendered page looks right and only client-side
 * pagination dies.
 *
 * `api/test/town-square/search-union-possible-types.spec.ts` fails if this map and the
 * schema's `union` / `interface` declarations drift apart.
 */
export const GRAPHQL_POSSIBLE_TYPES: Record<string, string[]> = {
  CommunityFeedItem: ['CommunityPost', 'PlatformFeedCard'],
  SearchResultNode: ['CommunityPost', 'Community', 'CommunityComment', 'ProfileSearchResult', 'Hashtag'],
  UserActivityItem: ['FeedPost', 'CommunityPost'],
};
